import { useGetLocale, useSetLocale, useTranslate } from "@refinedev/core";

export const useTranslation = (keyPrefix?: string) => {
  const translate = useTranslate();
  const changeLocale = useSetLocale();
  const getLocale = useGetLocale();

  type TranslateOptions = {
    [key: string]: string | number | boolean | null | undefined;
  };

  return {
    translate: keyPrefix
      ? (key: string, options?: TranslateOptions) =>
          translate(keyPrefix + "." + key, options)
      : translate,
    translateWithoutPrefix: translate,
    changeLocale,
    getLocale,
  };
};
